import { render, staticRenderFns } from "./ticketMessageList.vue?vue&type=template&id=820e6f7c&scoped=true&"
import script from "./ticketMessageList.vue?vue&type=script&lang=js&"
export * from "./ticketMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ticketMessageList.vue?vue&type=style&index=0&id=820e6f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820e6f7c",
  null
  
)

export default component.exports